import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { gqlClient } from '../../_services';

import loadingGif from '../../_assets/images/loading.gif';
import JobTypeVisual from '../shares/job-type-visual';

class HomeLatestJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentWillMount() {
    await this.loadJobs();
  }

  loadJobs = async () => {
    await this.setState({ loading: true });
    const apiResponse = await gqlClient.request(JOBS_QUERY);
    if (!apiResponse.jobs) return;
    await this.setState({
      jobs: apiResponse.jobs,
      loading: false,
    });
  };

  render() {
    const { jobs, loading } = this.state;
    if (!jobs) return null;
    return (
      <div className="row mx-0">
        <div className="home-title col-12">
          <span className="text-green">最新求人情報</span>
        </div>
        {loading && (
          <div className="col-12 loading">
            <img className="img-loading" src={loadingGif} alt="loading" />
          </div>
        )}

        {jobs.edges.map((job) => (
          <Link
            key={job.node.id}
            className="col-lg-4 col-6 mb-3"
            to={`/company/${job.node.company.id}/job/${job.node.id}/`}>
            <JobTypeVisual type={job.node.job_type} />
            <p className="mt-1 mb-1 title">{job.node.title}</p>
            <p className="mb-1 subtitle">{job.node.company.name}</p>
            <p className="mb-0 subtitle">{job.node.location}</p>
          </Link>
        ))}

        <div className="mt-4 px-0 col-12 text-center">
          <Link to="/jobs/" className="text-green small">
            <b>もっと見る</b>
          </Link>
        </div>
      </div>
    );
  }
}

const JOBS_QUERY = `
  query Jobs {
    jobs( first: 6 ) {
      edges {
        node {
          id
          title
          location
          job_type
          company {
            id
            name
          }
        }
      }
    }
  }
`;

HomeLatestJobs.propTypes = {
  homeLatestJobs: PropTypes.array,
};
export default HomeLatestJobs;
